import { DownOutlineIcon, VOutlineIcon } from '@carboncopyco/icons';
import type { DemoLinkPlatform } from '@carboncopyco/types';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { demoLinkPlatformTypes } from './consts';

type DemoLinkPlatformItemProps = {
  disabled?: boolean;
  platform: DemoLinkPlatform;
} & (
  | { isSelected: boolean; variant?: 'option' }
  | { isSelected?: never; variant?: 'trigger' }
);

export const DemoLinkPlatformItem = ({
  platform,
  variant = 'option',
  isSelected = false,
  disabled,
}: DemoLinkPlatformItemProps) => {
  const Icon = demoLinkPlatformTypes[platform].icon;
  const color =
    variant === 'option' ? ColorHex.natural600 : ColorHex.primary300;
  const dsColor =
    !disabled && variant === 'option'
      ? 'text-ds-natural-600'
      : 'text-ds-primary';

  return (
    <div
      className={classNames(
        'py-3 px-5 flex items-center justify-between rounded-lg',
        {
          'bg-ds-natural-50': !disabled || variant === 'trigger',
        }
      )}
    >
      <div className="flex items-center gap-4">
        <div className={classNames('flex items-center', dsColor)}>
          <Icon
            color={color}
            size={30}
          />
        </div>
        <div className="flex flex-col items-start">
          <div className={classNames('flex items-center gap-2', dsColor)}>
            <TextBase
              color={dsColor}
              label={demoLinkPlatformTypes[platform].label}
            />
            <div className="h-6">
              {!disabled && variant === 'trigger' && <DownOutlineIcon />}
            </div>
          </div>
          <TextBase label={demoLinkPlatformTypes[platform].description} />
        </div>
      </div>
      {!disabled && isSelected && <VOutlineIcon size={30} />}
    </div>
  );
};
